import React from 'react';
import { useTranslation } from 'react-i18next';
import regex from '../utils/regexUtils';

import { Text } from '@wegroup/design-system';
import CarSearchInput, {
  CarSearchInputProps,
} from './car-search-input/CarSearchInput';

interface Props {
  licensePlate?: string;
  setLicensePlate: (value: string) => void;
}

const LicensePlateSearchInput: React.FC<
  React.PropsWithChildren<Props & CarSearchInputProps>
> = ({ disabled, licensePlate, setLicensePlate, ...otherProps }) => {
  const { t } = useTranslation();
  const requiredLength = 6;

  return (
    <CarSearchInput
      value={licensePlate}
      setValue={setLicensePlate}
      inputMaxLength={requiredLength}
      inputPattern={regex.licensePlateNL.toString()}
      validationError={
        licensePlate &&
        licensePlate?.length > 0 &&
        licensePlate?.length !== requiredLength &&
        (licensePlate?.length < requiredLength
          ? (t('too short') as string)
          : (t('too long') as string))
      }
      disabled={disabled || licensePlate?.length !== requiredLength}
      isNumberPlate
      example={
        <>
          <Text as="span" textDecor="underline">
            {t('EXAMPLE')}:
          </Text>
          <span>
            {' '}
            &quot;18HKBR&quot;, &quot;35GFL9&quot; {t('and')}{' '}
            &quot;2KDL81&quot;.
          </span>
        </>
      }
      {...otherProps}
    />
  );
};

export default LicensePlateSearchInput;
